/*
 * @Desc: 
 * @Author: lc
 * @Date: 2023-08-14 16:54:15
 * @LastEditors: lc
 * @LastEditTime: 2023-08-14 16:58:44
 */
/**
  * 广告 接口的统一出口
  */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来

const api = '/c-api/';

const defaultshopthumb = {
    // 列表
    list (params) {
        return axios.get(api + 'defaultshopthumb/list', { params: params });
    },
    // 添加
    create (params) {
        return axios.post(api + 'defaultshopthumb/create', qs.stringify(params))
    },
    // 修改
    edit (params) {
        return axios.post(api + 'defaultshopthumb/edit', qs.stringify(params))
    },
    // 单个查看
    detail (params) {
        return axios.get(api + 'defaultshopthumb/detail', { params: params })
    },
    // 删除
    remove (params) {
        return axios.post(api + 'defaultshopthumb/remove', qs.stringify(params))
    },
}


// 导出接口
export default defaultshopthumb